module.exports = __webpack_public_path__ + "static/img/kinokobae.65f7b13.jpg";